import { Skeleton } from "antd";
import { Suspense } from "react";
import { Outlet } from "react-router";
import { BreadcrumbMenu } from "~Common/BreadcrumbMenu/BreadcrumbMenu.tsx";
import { useAppSettings } from "~context/AppSettingsContext/AppSettingsContext.tsx";
import { Footer } from "../Footer/Footer.tsx";

export const Content = () => {
  const { displayWidthConstrained } = useAppSettings();
  return (
    <div className={displayWidthConstrained ? "constrained-wrapper" : "not-constrained-wrapper"}>
      <div className={`main-content ${displayWidthConstrained ? "constrained-content" : ""}`}>
        <div className="breadcrumb-menu-wrapper">
          <BreadcrumbMenu />
        </div>
        <Suspense fallback={<Skeleton />}>
          <Outlet />
        </Suspense>
      </div>
      <div className="footer-wrapper">
        <Footer />
      </div>
    </div>
  );
};
